import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function IsItForYou() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-t border-white/5" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-133">
          {/* Green Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#0A1F11] border border-green-500/30 p-8 rounded-3xl" data-id="element-134">
            <h3 className="text-3xl text-green-400 mb-8" data-id="element-135">SI ES PARA VOS SI:</h3>
            <ul className="space-y-6" data-id="element-136">
              {['Querés aprender una habilidad real', 'Buscás ingresos adicionales', 'Te interesan remodelaciones', 'Querés avanzar a tu ritmo', 'No tenés experiencia previa'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-137">
                  <div className="bg-green-500/20 p-1 rounded-full mt-1" data-id="element-138">
                    <Check className="text-green-500 w-5 h-5" strokeWidth={3} data-id="element-139" />
                  </div>
                  <span className="text-lg text-gray-200 font-medium" data-id="element-140">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Red Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1F0A0A] border border-red-500/30 p-8 rounded-3xl" data-id="element-141">
            <h3 className="text-3xl text-red-500 mb-8" data-id="element-142">NO ES PARA VOS SI:</h3>
            <ul className="space-y-6" data-id="element-143">
              {['Buscás resultados mágicos', 'No estás dispuesto a aprender', 'Querés enriquecerte sin trabajar', 'No vas a aplicar lo aprendido'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-144">
                  <div className="bg-red-500/20 p-1 rounded-full mt-1" data-id="element-145">
                    <X className="text-red-500 w-5 h-5" strokeWidth={3} data-id="element-146" />
                  </div>
                  <span className="text-lg text-gray-200 font-medium" data-id="element-147">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}